export const PROD_URL = "https://vgf-static.beefee.co.uk/";
export const PROD_URL_ALTERNATIVE_DOMAIN_1 = "https://vgf-static.beefee1.co.uk/";
export const PROD_URL_ALTERNATIVE_DOMAIN_2 = "https://vgf-static.traversevistabg.com/";
export const DEV_URL = "https://gs-client-newjenkins.testowaplatforma123.net/"

export const PROD_URL_REDIRECTS = "https://vgf-static.beefee.co.uk/redirects/";
export const PROD_URL_REDIRECTS_ALTERNATIVE_DOMAIN_1 = "https://vgf-static.beefee1.co.uk/redirects/";
export const PROD_URL_REDIRECTS_ALTERNATIVE_DOMAIN_2 = "https://vgf-static.traversevistabg.com/redirects/";
export const DEV_URL_REDIRECTS = "https://gs-client-newjenkins.testowaplatforma123.net/redirects/"

export const RETRY_BASE_TIME = 1_000;
export const RETRY_BASE_ATTEMPTS = 3;

// TODO: remove when the headers test will be completed
export const PROD_URL_HEADERS_TEST = "https://vgf-static-testheaders.beefee.co.uk/";
export const PROD_URL_REDIRECTS_HEADERS_TEST = "https://vgf-static-testheaders.beefee.co.uk/redirects/";
